import { GlobalStyles, useTheme } from '@mui/material';
import { Browser } from 'enums';
import useBrowser from 'hooks/use-browser';

const GlobalScrollbarStyles = () => {
  const theme = useTheme();

  const { userBrowser } = useBrowser();

  const firefoxStyles = {
    /* Firefox styles */
    '*': {
      scrollBarWidth: 'auto',
      scrollbarColor: `${theme.palette.greys.medium} ${theme.palette.greys.lightest}`,
    },
    '*:hover': {
      scrollbarColor: `${theme.palette.primary.main} ${theme.palette.greys.lightest}`,
    },
  };

  const webkitStyles = {
    /* Chromium & -webkit styles */
    '*::-webkit-scrollbar': {
      width: '16px',
      height: '16px',
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.greys.lightest,
    },
    '*::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '5px solid transparent',
      backgroundClip: 'content-box',
      backgroundColor: theme.palette.greys.medium,
      '&:hover': {
        border: '3px solid transparent',
        backgroundColor: theme.palette.primary.main,
      },
    },
    '*::-webkit-scrollbar-button': {
      backgroundColor: theme.palette.greys.lightest,
      width: '0px',
      height: '0px',
    },
    '*::-webkit-scrollbar-button:single-button:vertical:decrement': {
      height: '16px',
      width: '16px',
      background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
        theme.palette.greys.medium
      )}" viewBox="0 0 24 24" width="16" height="16"><path d="M12 8l-4.5 4.5a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0L12 10.4l3.1 3.1a1 1 0 0 0 1.4 0 1 1 0 0 0 0-1.4L12 8z"/></svg>') no-repeat center`,
      backgroundColor: theme.palette.greys.lightest,
      '&:hover': {
        background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
          theme.palette.primary.main
        )}" viewBox="0 0 24 24" width="20" height="20"><path d="M12 8l-4.5 4.5a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0L12 10.4l3.1 3.1a1 1 0 0 0 1.4 0 1 1 0 0 0 0-1.4L12 8z"/></svg>') no-repeat center`,
        backgroundColor: theme.palette.greys.lightest,
      },
    },
    '*::-webkit-scrollbar-button:single-button:vertical:increment': {
      height: '16px',
      width: '16px',
      background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
        theme.palette.greys.medium
      )}" viewBox="0 0 24 24" width="16" height="16"><path d="M12 16l-4.5-4.5a1 1 0 0 1 0-1.4 1 1 0 0 1 1.4 0L12 13.6l3.1-3.1a1 1 0 0 1 1.4 0 1 1 0 0 1 0 1.4L12 16z"/></svg>') no-repeat center`,
      backgroundColor: theme.palette.greys.lightest,
      '&:hover': {
        background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
          theme.palette.primary.main
        )}" viewBox="0 0 24 24" width="20" height="20"><path d="M12 16l-4.5-4.5a1 1 0 0 1 0-1.4 1 1 0 0 1 1.4 0L12 13.6l3.1-3.1a1 1 0 0 1 1.4 0 1 1 0 0 1 0 1.4L12 16z"/></svg>') no-repeat center`,
        backgroundColor: theme.palette.greys.lightest,
      },
    },
    '*::-webkit-scrollbar-button:single-button:horizontal:decrement': {
      height: '16px',
      width: '16px',
      background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
        theme.palette.greys.medium
      )}" viewBox="0 0 24 24" width="16" height="16"><path d="M8 12l4.5-4.5a1 1 0 0 1 1.4 0 1 1 0 0 1 0 1.4L10.4 12l3.1 3.1a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0L8 12z"/></svg>') no-repeat center`,
      backgroundColor: theme.palette.greys.lightest,
      '&:hover': {
        background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
          theme.palette.primary.main
        )}" viewBox="0 0 24 24" width="20" height="20"><path d="M8 12l4.5-4.5a1 1 0 0 1 1.4 0 1 1 0 0 1 0 1.4L10.4 12l3.1 3.1a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0L8 12z"/></svg>') no-repeat center`,
        backgroundColor: theme.palette.greys.lightest,
      },
    },
    '*::-webkit-scrollbar-button:single-button:horizontal:increment': {
      height: '16px',
      width: '16px',
      background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
        theme.palette.greys.medium
      )}" viewBox="0 0 24 24" width="16" height="16"><path d="M16 12l-4.5 4.5a1 1 0 0 1-1.4 0 1 1 0 0 1 0-1.4L13.6 12l-3.1-3.1a1 1 0 0 1 0-1.4 1 1 0 0 1 1.4 0L16 12z"/></svg>') no-repeat center`,
      backgroundColor: theme.palette.greys.lightest,
      '&:hover': {
        background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="${encodeURIComponent(
          theme.palette.primary.main
        )}" viewBox="0 0 24 24" width="20" height="20"><path d="M16 12l-4.5 4.5a1 1 0 0 1-1.4 0 1 1 0 0 1 0-1.4L13.6 12l-3.1-3.1a1 1 0 0 1 0-1.4 1 1 0 0 1 1.4 0L16 12z"/></svg>') no-repeat center`,
        backgroundColor: theme.palette.greys.lightest,
      },
    },
  };

  return <GlobalStyles styles={userBrowser === Browser.FIREFOX ? firefoxStyles : webkitStyles} />;
};

export default GlobalScrollbarStyles;
